import intl from 'react-intl-universal';

import { ReducerState } from '@/redux/reducers/reservation/checkInEditor';
import { findItemByKey } from '@/redux/actions/reservation/helper';
import { SourceChannelType } from '@/config/constant';
import { PRICE_REG } from '@/config/reg';
import {
  ValidateSchema,
  channelOrderNoValidater,
  createValidator,
} from '@/pages/reservation/utils/validator';

const rentTimeInfo: (value: ReducerState['rentTimeInfo']) => void = (value) => {
  const { rentTime } = value;

  if (!rentTime) {
    throw new Error(intl.get('reservation_error_duration_null'));
  }

  return null;
};

const channelInfo: (value: ReducerState['channelInfo'], data: ReducerState) => void = (
  value,
  data,
) => {
  const { channelId, channelOrderNo } = value;
  const { channelList } = data;
  const targetChannel = findItemByKey(channelList, 'id', channelId);
  // OTA 渠道 且非直连
  const shouldCheckOrder =
    targetChannel && targetChannel.type === SourceChannelType.OTA && !targetChannel.directFlag;

  let err;
  switch (true) {
    case !channelId:
      err = 'reservation_error_channel_null';
      break;
    case shouldCheckOrder && !channelOrderNo:
      err = 'reservation_error_ota_no_null';
      break;
    case shouldCheckOrder && !channelOrderNoValidater(targetChannel.otaBillType, channelOrderNo):
      err = 'reservation_error_channelNo_format';
      break;
    default:
      return '';
  }

  if (err) {
    throw new Error(intl.get(err));
  }
  return null;
};

const rentRoomInfos: (value: ReducerState['rentRoomInfos']) => void = (value) => {
  const rentList = value || [];
  let err;

  if (rentList.length) {
    rentList.forEach((item) => {
      const { roomPriceList, deposit } = item;
      if (!deposit) throw new Error(intl.get('reservation_error_room_deposit_null'));
      if (!PRICE_REG.test(deposit))
        throw new Error(intl.get('reservation_error_room_deposit_invalid'));
      (roomPriceList || []).forEach((rentDay) => {
        if (!rentDay.inputPrice) {
          throw new Error(intl.get('reservation_error_room_price_null'));
        }
        if (!PRICE_REG.test(rentDay.inputPrice)) {
          throw new Error(intl.get('reservation_error_room_price_invalid'));
        }
      });
    });
  } else {
    err = intl.get('reservation_error_room_count_null');
  }

  if (err) {
    throw new Error(err);
  }
  return null;
};

const mainSchema: ValidateSchema<ReducerState> = {
  rentTimeInfo,
  channelInfo,
  rentRoomInfos,
};

export default createValidator<ReducerState>(mainSchema);
